module.exports = __webpack_public_path__ + "img/gis4.519bd756.png";